'use client';

import { useEffect } from 'react';
import { TokenManager } from '@/lib/auth/token-manager';
import { usePathname } from 'next/navigation';

/**
 * Composant qui gère le rafraîchissement automatique des tokens d'authentification.
 * Ce composant n'a pas de rendu visuel, il initialise simplement le mécanisme
 * de rafraîchissement automatique des tokens lorsque l'utilisateur est connecté.
 */
export default function TokenRefreshManager() {
  const pathname = usePathname();
  
  useEffect(() => {
    // Vérifier si l'utilisateur est sur une page qui nécessite l'authentification
    const isAuthPage = pathname === '/login' || pathname === '/register' || pathname === '/forgot-password';
    
    // Vérifier si l'utilisateur est authentifié
    const isAuthenticated = TokenManager.isAuthenticated();
    
    console.log('🔄 TokenRefreshManager: Initialisation', {
      page: pathname,
      isAuthPage,
      isAuthenticated
    });
    
    // Initialiser le rafraîchissement automatique uniquement si l'utilisateur est authentifié
    // et n'est pas sur une page d'authentification
    if (isAuthenticated && !isAuthPage) {
      console.log('🔄 TokenRefreshManager: Activation du rafraîchissement automatique');
      TokenManager.initTokenRefresh();
    } else {
      console.log('🔄 TokenRefreshManager: Désactivation du rafraîchissement automatique');
      TokenManager.stopTokenRefresh();
    }
    
    // Nettoyer lors du démontage du composant
    return () => {
      console.log('🔄 TokenRefreshManager: Nettoyage');
      TokenManager.stopTokenRefresh();
    };
  }, [pathname]);
  
  // Ce composant n'a pas de rendu visuel
  return null;
}
